export const AVATAR_SIZE = 256;
const maxBytes = 5 * 1024 * 1024;

export function validateAvatarFile(file: File) {
  if (!file.size || file.size > maxBytes) throw new Error('请选择 5 MB 以内的头像图片');
  if (!['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(file.type))
    throw new Error('请选择 JPEG、PNG、WebP 或 GIF 图片');
}

export function validateAvatarDimensions(width: number, height: number) {
  if (width < 1 || height < 1 || width > 10000 || height > 10000 || width * height > 24000000)
    throw new Error('请选择 2400 万像素以内的图片');
}

export function avatarCrop(width: number, height: number, zoom = 1, x = 0.5, y = 0.5) {
  const side = Math.min(width, height) / Math.max(1, Math.min(3, zoom));
  return {
    x: Math.max(0, Math.min(1, x)) * (width - side),
    y: Math.max(0, Math.min(1, y)) * (height - side),
    side,
  };
}

export function loadAvatarImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('图片无法读取，请重新选择'));
    image.src = url;
  });
}

export async function encodeAvatar(image: HTMLImageElement, crop: ReturnType<typeof avatarCrop>) {
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = AVATAR_SIZE;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('当前浏览器无法处理图片，请更新浏览器后重试');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, AVATAR_SIZE, AVATAR_SIZE);
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  ctx.drawImage(image, crop.x, crop.y, crop.side, crop.side, 0, 0, AVATAR_SIZE, AVATAR_SIZE);
  const blob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(
      (value) => (value ? resolve(value) : reject(new Error('图片处理失败，请重试'))),
      'image/jpeg',
      0.82,
    ),
  );
  if (blob.type !== 'image/jpeg' || !blob.size || blob.size > maxBytes)
    throw new Error('头像转换失败，请重新选择图片');
  return new File([blob], 'avatar.jpg', { type: 'image/jpeg' });
}
